module.exports = __webpack_public_path__ + "img/mrxweb.88b20609.svg";